import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AdminPageShellComponent } from '../../../shared/components/admin/admin-page-shell/admin-page-shell.component';
import { PersonalDataEditorComponent } from '../../user/components/personal-data-editor/personal-data-editor.component';
import { AdminService } from '../../user/service/admin.service';

@Component({
  selector: 'app-admin-profile',
  standalone: true,
  imports: [CommonModule, AdminPageShellComponent, PersonalDataEditorComponent],
  templateUrl: './admin-profile.component.html',
  styleUrl: './admin-profile.component.scss',
})
export class AdminProfileComponent {
  readonly #adminService = inject(AdminService);

  readonly admin = this.#adminService.admin;
}
